<div class="radios">
    <ng-container *ngFor="let option of options; trackBy: trackByFn">
        <label class="input-radio-wrap">
          <input type="radio" class="input-radio"
              (change)="onChanged(option.value)"
              [value]="option.value"
              [checked]="isChecked(option.value)"
              [attr.disabled]="isDisabled || option.disabled ? true : null">
          <span class="input-radio-item"></span>
          <span class="label-input-radio normal">{{ option.title | customLocale }}</span>
        </label>
    </ng-container>
</div>

